import './components/navigation';
import './components/filter';
import './components/faq';
import './components/search-toggle';
import './components/social-share';
import './components/counter';
import './components/fancybox';
import './components/popups';

// Vue
import './vue/posts.js';
import './vue/search.js';

$('form select').on("change", function () {
    this.classList.add('selected');
})
